var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.data.labels.length)?_c('Pie',{attrs:{"chart-data":_vm.data,"chart-options":_vm.options}}):_c('a-empty')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }